import React from 'react'
import { Switch, Route, Redirect } from 'react-router-dom'
import { CheckoutProvider } from 'lib/shared/components'
import { BillingScene, ShippingScene, SuccessScene } from 'lib/modules/checkout'

export const CheckoutScene = () => {
  return (
    <CheckoutProvider>
      <Switch>
        <Route
          exact
          path='/checkout/shipping'
          component={ShippingScene}
        />

        <Route
          exact
          path='/checkout/billing'
          component={BillingScene}
        />

        <Route
          exact
          path='/checkout/success'
          component={SuccessScene}
        />

        <Redirect
          to='/checkout/shipping'
        />
      </Switch>
    </CheckoutProvider>
  )
}
